import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetDynamicBaseComponent } from '../../widgetDynamicBase';

/**
 * Direct Cap PGI Summary Widget
 */
@Component({
  selector: 'direct-cap-pgi-summary-widget',
  templateUrl: './direct-cap-pgi-summary-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './direct-cap-pgi-summary-widget.component.scss']
})
export class DirectCapPgiSummaryWidgetComponent extends WidgetDynamicBaseComponent implements OnInit {
  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'directCapPGISummary', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();

  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler('directCapPGISummary', this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('directCapPGISummary').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('directCapPGISummary', this.getReport()).pipe();
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  public getMinimumRowIndex(): number {
    return 1;
  }

  public getMaximumRowIndex(): number {
    return 7;
  }

  public moreColumnsRequestedIfOnPortraitPage(): boolean {
    return false;
  }
}
